import { convertFromSapDate } from 'src/app/lego-utils';

export type NullableString = string | null | undefined;

export function fallbackString(value: NullableString): string {
  return value ?? '';
}

export function fallbackDate(value: NullableString): Date | undefined {
  return convertFromSapDate(value) ?? undefined;
}
